<template>
    <v-card-text v-if="task" class="pa-0">
        <div :id="printId || 'printMe'" class="white" style="padding: 2em;">
            <div
                style="
                    display: flex;"
            >
                <div>
                    <qrcode-vue
                        :value="qrCodeValue"
                        :size="size"
                        level="L"
                        render-as="svg"
                    />
                </div>
                <div style="margin-left: 2em">
                    <p>
                        <b>{{ task.plant.plantSpecies.name }}</b
                        ><br />
                        <b>{{ task.plant.name }}</b>
                        <b><span v-if="task.potSize">
                            / {{ task.potSize.potSizeCm }}cm</span
                        ></b>
                        <b><span v-if="task.color">
                            / {{ task.color.color }}
                        </span></b>
                        <b>
                            <br />{{
                                task.growthStartDate | moment("YYYY-[W]WW")
                            }}
                            / ID{{ task.rawId }}</b
                        >
                        <b v-if="task.supplier">
                            <br />{{ task.supplier.name }}</b
                        >
                        <br />
                        <b>Plants: {{ task.totalInventory }}</b>
                    </p>
                </div>
            </div>
        </div>
    </v-card-text>
</template>

<script>
import QrcodeVue from "qrcode.vue";

export default {
    name: "growth-task-qr-code",
    props: ["task", "printId"],
    components: {
        QrcodeVue
    },

    data: function() {
        return {
            // QRCode
            size: 100
        };
    },

    computed: {
        qrCodeValue() {
            return "growthtask:" + this.task.id;
        }
    },
    methods: {}
};
</script>


<style scoped>
@media print {
    @page {
        size: auto; /* auto is the initial value */
        margin: 0mm; /* this affects the margin in the printer settings */
    }
    html {
        background-color: #ffffff;
        margin: 0mm; /* this affects the margin on the html before sending to printer */
    }
    body {
        padding: 30px; /* margin you want for the content */
    }
}

.box-border {
    border-style: solid;
    padding: 30px;
}
</style>
